import { render, staticRenderFns } from "./RegisterStep4.vue?vue&type=template&id=75169252&"
import script from "./RegisterStep4.vue?vue&type=script&lang=js&"
export * from "./RegisterStep4.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStep4.vue?vue&type=style&index=0&id=75169252&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports